// Attach event listeners for quantity input buttons
function updateQuantityInput(input, delta) {
  const current = parseInt(input.value) || 1;
  const min = parseInt(input.getAttribute('min')) || 0;
  const max = parseInt(input.getAttribute('max')) || 9999;
  let next = current + delta;
  if (next < min) next = min;
  if (next > max) next = max;
  input.value = next;
  input.dispatchEvent(new Event('change', { bubbles: true }));
}

// Store references to handlers to allow removal
const quantityHandlers = new WeakMap();

function getHandler(input, delta) {
  // Use a unique handler per input+delta
  let handlers = quantityHandlers.get(input);
  if (!handlers) {
    handlers = {};
    quantityHandlers.set(input, handlers);
  }
  if (!handlers[delta]) {
    handlers[delta] = function(e) {
      e.preventDefault();
      updateQuantityInput(input, delta);
    };
  }
  return handlers[delta];
}

function attachQuantityInputListeners(context = document) {
  // For each quantity input block
  context.querySelectorAll('.quantity-input, .QuantitySelector').forEach(block => {
    const input = block.querySelector('input[type="number"], input.QuantitySelector__CurrentQuantity, input.quantity-input__current-quantity');
    if (!input) return;
    // Increase
    block.querySelectorAll('[data-action="increase-quantity"]').forEach(btn => {
      const handler = getHandler(input, 1);
      btn.removeEventListener('click', handler);
      btn.addEventListener('click', handler);
    });
    // Decrease
    block.querySelectorAll('[data-action="decrease-quantity"]').forEach(btn => {
      const handler = getHandler(input, -1);
      btn.removeEventListener('click', handler);
      btn.addEventListener('click', handler);
    });
  });
}

// Auto-attach on DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    attachQuantityInputListeners();
  });
} else {
  attachQuantityInputListeners();
}

// Expose for dynamic use
window.attachQuantityInputListeners = attachQuantityInputListeners;
